module.exports = __webpack_public_path__ + "img/88-3a4169.png";